import api from './api';

export const getRoles = () => api.get('/v1/roles');
export const getRole = (id) => api.get(`/v1/roles/${id}`);
export const createRole = (data) => api.post('/v1/roles', data);
export const updateRole = (id, data) => api.put(`/v1/roles/${id}`, data);
export const deleteRole = (id) => api.delete(`/v1/roles/${id}`);
export const updateRolePermissions = (id, data) => api.put(`/v1/roles/${id}/permissions`, data);
export const getRoleUsers = (id) => api.get(`/v1/roles/${id}/users`);
export const assignRoleUser = (id, data) => api.post(`/v1/roles/${id}/users`, data);
export const removeRoleUser = (id, userRoleId) => api.delete(`/v1/roles/${id}/users/${userRoleId}`);
// AKM POC §9.3 — atamanın veri kapsamı. Gövde: { dataScopeType, dataScopeTargetIds }.
export const updateRoleUserScope = (id, userRoleId, data) => api.put(`/v1/roles/${id}/users/${userRoleId}/scope`, data);

// ═══ Pozisyona bağlı rol ═══
// Yazma yolu TEK: rol üzerinden. Pozisyon okuması da rol denetleyicisindedir —
// PositionController EM.Read kapılı ve EM VARSAYILAN modül olduğu için orada kapı yok.
export const getRolePositions = (id) => api.get(`/v1/roles/${id}/positions`);
export const assignRolePosition = (id, data) => api.post(`/v1/roles/${id}/positions`, data);
export const removeRolePosition = (id, positionRoleId) =>
  api.delete(`/v1/roles/${id}/positions/${positionRoleId}`);
export const getPositionRoles = (positionId) => api.get(`/v1/roles/by-position/${positionId}`);
export const updateRolePositionScope = (id, positionRoleId, data) =>
  api.put(`/v1/roles/${id}/positions/${positionRoleId}/scope`, data);
